import Link from 'next/link';

export default function Button({
  variant = 'primary',
  href,
  onClick,
  className = '',
  children,
  ...props
}) {
  // Base styles shared across variants
  const baseStyles =
    'inline-flex items-center justify-center px-4 py-2.5 rounded text-sm font-semibold shadow transition hover:shadow-md hover:brightness-80 text-nowrap';

  // Variant-specific styling
  const variantStyles = {
    primary: 'bg-primary border-primary text-primary-foreground',
    secondary: 'bg-secondary border-secondary text-secondary-foreground',
    accent: 'bg-accent border-accent text-accent-foreground',
    ghost:
      'bg-transparent border border-primary-foreground text-primary-foreground',
    muted: 'bg-muted border-muted text-muted-foreground',
    destructive: 'bg-destructive border-destructive text-primary-foreground',
  };

  // Combine base styles, variant styles, and any additional classes
  const finalClassName =
    `${baseStyles} ${variantStyles[variant] || ''} ${className}`.trim();

  return (
    <Link
      href={href || '#'}
      onClick={onClick}
      className={finalClassName}
      {...props}
    >
      {children}
    </Link>
  );
}
